import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const Disclaimer = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      
      <main className="container mx-auto px-4 py-12 max-w-4xl">
        <h1 className="text-3xl font-bold text-gray-900 mb-8">Disclaimer - Avertissement</h1>
        
        <div className="bg-white rounded-lg shadow-sm p-8 space-y-8">
          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-4">1. Objet du site</h2>
            <p className="text-gray-700">
              123pariez.com est un site comparateur indépendant qui a pour vocation de présenter et 
              comparer les différents sites de paris sportifs et de casino en ligne agréés en France. 
              Notre objectif est de fournir aux utilisateurs des informations claires et objectives 
              pour les aider dans leur choix d'opérateur.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-4">2. Méthodologie de notation</h2>
            <p className="text-gray-700 mb-4">
              Les notes et classements présentés sur notre site sont établis selon <strong>nos propres 
              critères d'évaluation</strong> et reflètent notre opinion éditoriale. Ces critères incluent, 
              sans s'y limiter :
            </p>
            <ul className="list-disc list-inside text-gray-700 space-y-2 ml-4">
              <li><strong>Qualité de l'offre de bienvenue :</strong> Montant, conditions de mise, clarté des termes</li>
              <li><strong>Variété des paris proposés :</strong> Sports couverts, types de paris, cotes proposées</li>
              <li><strong>Expérience utilisateur :</strong> Interface, application mobile, facilité de navigation</li>
              <li><strong>Moyens de paiement :</strong> Options de dépôt et retrait, délais de traitement</li>
              <li><strong>Service client :</strong> Disponibilité, réactivité, qualité des réponses</li>
              <li><strong>Fiabilité et sécurité :</strong> Licence, historique de l'opérateur, protection des données</li>
              <li><strong>Promotions régulières :</strong> Offres pour les clients existants, programme de fidélité</li>
            </ul>
            <p className="text-gray-700 mt-4">
              Ces notations sont subjectives et peuvent différer d'autres sources. Nous vous encourageons 
              à effectuer vos propres recherches avant de vous inscrire sur un site de paris.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-4">3. Liens d'affiliation</h2>
            <p className="text-gray-700">
              123pariez.com peut percevoir une commission lorsque vous vous inscrivez sur un site de 
              paris sportifs via nos liens. Cette rémunération nous permet de maintenir notre site 
              et de continuer à fournir des comparatifs gratuits et de qualité. 
            </p>
            <p className="text-gray-700 mt-4">
              <strong>Important :</strong> Les commissions d'affiliation n'influencent pas nos évaluations. 
              Notre méthodologie de notation reste indépendante et basée uniquement sur les critères 
              mentionnés ci-dessus. L'ordre de présentation des opérateurs peut toutefois tenir compte 
              de nos partenariats commerciaux.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-4">4. Exactitude des informations</h2>
            <p className="text-gray-700">
              Nous nous efforçons de maintenir les informations présentées sur notre site à jour et exactes. 
              Cependant, les offres, bonus et conditions des opérateurs peuvent changer à tout moment 
              sans préavis.
            </p>
            <p className="text-gray-700 mt-4">
              <strong>Nous vous recommandons vivement</strong> de toujours vérifier les conditions exactes 
              directement sur le site officiel de l'opérateur avant de vous inscrire ou de réclamer 
              une offre. 123pariez.com ne peut être tenu responsable des éventuelles différences entre 
              les informations affichées sur notre site et celles des opérateurs.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-4">5. Opérateurs agréés</h2>
            <p className="text-gray-700">
              Tous les sites de paris sportifs et de casino présentés sur 123pariez.com sont 
              <strong> agréés par l'Autorité Nationale des Jeux (ANJ)</strong>, anciennement ARJEL. 
              Cette licence garantit que l'opérateur respecte la réglementation française en matière 
              de jeux d'argent en ligne, notamment en termes de protection des joueurs et d'intégrité 
              des opérations.
            </p>
            <p className="text-gray-700 mt-4">
              Nous ne référençons aucun site illégal ou non agréé en France.
            </p>
          </section>

          <section className="bg-amber-50 border border-amber-200 rounded-lg p-6">
            <h2 className="text-xl font-semibold text-amber-800 mb-4">6. Jeu responsable</h2>
            <p className="text-amber-700 mb-4">
              Les jeux d'argent et de hasard comportent des risques. Ils peuvent créer une dépendance 
              et entraîner des pertes financières importantes.
            </p>
            <ul className="list-disc list-inside text-amber-700 space-y-2">
              <li>Les jeux d'argent sont <strong>strictement interdits aux mineurs</strong> (moins de 18 ans)</li>
              <li>Ne jouez jamais plus que ce que vous pouvez vous permettre de perdre</li>
              <li>Le jeu ne doit pas être considéré comme un moyen de gagner de l'argent</li>
              <li>Fixez-vous des limites de temps et d'argent avant de jouer</li>
              <li>Ne jouez jamais pour vous "refaire" après une perte</li>
            </ul>
            <p className="text-amber-700 mt-4">
              Si vous pensez avoir un problème avec le jeu, des ressources d'aide sont disponibles :
            </p>
            <div className="mt-4 p-4 bg-white rounded-lg">
              <p className="font-semibold text-gray-900">Joueurs Info Service</p>
              <p className="text-gray-700">Téléphone : <strong>09 74 75 13 13</strong> (appel non surtaxé)</p>
              <p className="text-gray-700">Site web : <a href="https://www.joueurs-info-service.fr" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">www.joueurs-info-service.fr</a></p>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-4">7. Limitation de responsabilité</h2>
            <p className="text-gray-700">
              123pariez.com fournit des informations à titre indicatif uniquement. En aucun cas, 
              les informations présentes sur ce site ne constituent un conseil financier, juridique 
              ou un encouragement à jouer.
            </p>
            <p className="text-gray-700 mt-4">
              L'utilisateur est seul responsable de ses décisions de jeu et de ses éventuelles pertes. 
              123pariez.com et ses éditeurs déclinent toute responsabilité quant aux conséquences 
              directes ou indirectes de l'utilisation des informations présentes sur ce site.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-4">8. Propriété intellectuelle</h2>
            <p className="text-gray-700">
              Les logos et marques des opérateurs de paris sportifs présentés sur ce site sont la 
              propriété de leurs détenteurs respectifs. Leur utilisation sur 123pariez.com est faite 
              à des fins d'information et de comparaison uniquement.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-4">9. Contact</h2>
            <p className="text-gray-700">
              Pour toute question concernant ce disclaimer ou notre méthodologie de notation, 
              vous pouvez nous contacter via les coordonnées indiquées dans nos 
              <a href="/mentions-legales" className="text-blue-600 hover:underline ml-1">mentions légales</a>.
            </p>
          </section>

          <div className="pt-6 border-t border-gray-200">
            <p className="text-sm text-gray-500 text-center">
              Dernière mise à jour : Février 2025
            </p>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default Disclaimer;
